// https://vuex.vuejs.org/en/getters.html

export default {
  selectedItems: state => state.selectedItems,
  selectedItemsInBundling: state => state.selectedItemsInBundling,
  editQuoRecord: state => state.editQuoRecord
}
